import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FlyFreelyConstants } from '../constants';
import { NotamDto } from '../model/api';
import { httpParamSerializer } from './service.helpers';

export const notamProviderNameLookup = {
    ['ASA']: 'Air Services Australia'
};

@Injectable({
    providedIn: 'root'
})
export class NotamService {
    private baseUrl: string;

    constructor(constants: FlyFreelyConstants, private http: HttpClient) {
        this.baseUrl = constants.API_URL;
    }

    findNotamsForMission(location: string[], missionId: number) {
        return this.http.get<NotamDto[]>(`${this.baseUrl}/webapi/notams`, {
            params: httpParamSerializer({ location, missionId })
        });
    }

    findNotamsByJurisdiction(location: string[], jurisdictionId: number) {
        return this.http.get<NotamDto[]>(`${this.baseUrl}/webapi/notams`, {
            params: httpParamSerializer({ location, jurisdictionId })
        });
    }
}
